<template>
  <div class="mains">
    <div>
      <el-row :gutter="4"
              type="flex"
              style="margin-bottom:20px"
              align='middle'>
        <el-col :span="6">
          <el-button type="primary"
                     size="small"
                     @click="addSort">新增</el-button>
        </el-col>
        <el-col :span="3">
          店铺分类名称：
        </el-col>
        <el-col :span="6">
          <el-input v-model="sortName"
                    @clear='searClear'
                    clearable></el-input>
        </el-col>
        <el-col :span="2">
          <el-button size="small"
                     @click='getdecorateSortList'>搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table">
      <el-table :data="tableData"
                border
                ref="multipleTable"
                :row-class-name="handleCurrentIndex"
                @row-click='handleCurrentChange'
                highlight-current-row
                style="width: 800px">
        <el-table-column type="index"
                         width="55"
                         label="序号">
        </el-table-column>
        <el-table-column prop="imgs_mains"
                         label="分类图片"
                         width="180">
          <template slot-scope="scope">
            <img :src="scope.row.category_image"
                 style="width:80px">
          </template>
        </el-table-column>
        <el-table-column prop="categroy_name"
                         label="分类名称">
        </el-table-column>
        <el-table-column prop="goods_number"
                         label="关联商品">
        </el-table-column>
        <el-table-column prop="address"
                         label="操作">
          <template slot-scope="scope">
            <el-link style="margin-right:20px"
                     @click="clickEdit(scope.row.id)">编辑</el-link>
            <el-link type="danger"
                     @click="setdecorateGoodsDel(scope.row.id,scope.row.sort)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn">
        <el-button @click="upmove"><i class="el-icon-arrow-up"></i></el-button>
        <el-button @click="downmove"><i class="el-icon-arrow-down"></i></el-button>
      </div>
    </div>
    <div v-if="viewDetail">
      <fixSortAdd @closeModel='initModel'
                  :cate_goods_id='cate_goods_id'
                  :method="getdecorateSortList"
                  :title='title'></fixSortAdd>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fixAddGoods from './fixAddGoods.vue'
import fixSortAdd from './fixSortAdd.vue'
export default {
  props: {

  },
  data () {
    return {
      viewDetail: false,
      formLabelWidth: '100px',
      flag: false,
      indexRow: '',
      sortName: '',
      tableData: [],
      type: '',
      title: '',
      cate_goods_id: ''

    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },

  methods: {
    ...mapActions({
      decorateSortList: "detect/decorateSortList", //列表
      decorateGoodsSort: "detect/decorateGoodsSort", //排序
      decorateSortDelete: "detect/decorateSortDelete", //删除
      decorateSort: "detect/decorateSort", //排序
    }),

    handleCurrentChange (row) {
      this.indexRow = row
    },
    handleCurrentIndex ({ row, rowIndex }) {
      row.recom_sort = rowIndex
    },
    upmove () {
      this.type = 1
      let index = ''
      index = this.indexRow.sort
      if (this.indexRow.sort == 1) {
        this.$message.error('商品排序已在第一位');
      } else {
        this.setdecorateSort(index)
      }
    },
    downmove () {
      this.type = 2
      let index = this.indexRow.sort
      if (this.indexRow.sort == this.tableData.length) {
        this.$message.error('商品排序已在最后一位');
      } else {
        this.setdecorateSort(index)
      }
    },
    addSort () {
      if (this.tableData.length >= 10) {
        this.$message.error('主推商品位置已满，暂无法添加新主推商品！您可以先删除已有主推商品再进行新增');
      } else {
        this.title = '新增'
        this.tableindex = this.tableData.length
        this.viewDetail = true
      }
    },
    searClear () {
      this.page = 1
      this.sortName = ''
      this.getdecorateSortList()
    },
    initModel () {
      this.viewDetail = false
    },
    clickEdit (item) {
      this.title = '编辑'
      this.cate_goods_id = item
      this.viewDetail = true
    },
    getdecorateSortList () {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        page: 1,
        limit: 10,
        name: this.sortName ? this.sortName : '',
      }
      this.decorateSortList(params).then(res => {
        if (res.data.code == 1) {
          this.tableData = res.data.data.list
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    setdecorateGoodsSort (index) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        type: this.type,
        sort: index
      }
      this.decorateGoodsSort(params).then(res => {
        if (res.data.code == 1) {
          const len = this.tableData[index - 1]
          this.$set(this.tableData, index - 1, this.tableData[index])
          this.$set(this.tableData, index, len)
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    setdecorateGoodsDel (index, sort) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        id: index,
        sort: sort
      }
      this.decorateSortDelete(params).then(res => {
        if (res.data.code == 1) {
          this.getdecorateSortList()
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    setdecorateSort (index) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        type: this.type,
        sort: index
      }
      this.decorateSort(params).then(res => {
        if (res.data.code == 1) {
          this.getdecorateSortList()
        /*   if (this.type == 1) {
            const len = this.tableData[index + 1]
            console.log(len,'len----')
            this.$set(this.tableData, index + 1, this.tableData[index])
            this.$set(this.tableData, index, len)
          } else {
            const len = this.tableData[index - 1]
            this.$set(this.tableData, index - 1, this.tableData[index])
            this.$set(this.tableData, index, len)
          } */

        } else {
          this.$message.error(res.data.msg);
        }
      })
    }
  },
  components: {
    fixAddGoods, fixSortAdd
  },
};
</script>

<style scoped lang="scss">
.mains {
  width: 80%;
  padding: 20px;
  border: 1px solid #ccc;
  margin: 0 auto;
  .table {
    width: 800px;
    /*  border: 1px solid #ccc; */
    padding: 20px;
    margin: 0 auto;
  }
}
.btn {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-input--medium .el-input__inner {
  height: 30px;
  line-height: 30px;
}
</style>
